export const PROPERTY_VIEW_CONSUMPTION_CONSUMPTION_ID = 'propertyMBusDeviceTypeIdForConsumption';
export const PROPERTY_VIEW_CONSUMPTION_PIE_CHART_ID = 'propertyMBusDeviceTypeIdForPieChart';
